/**
 * Minimal in-app event emitter (replaces the window CustomEvent bus).
 *
 * Handlers receive the emitted payload directly (what used to be event.detail).
 */

const listeners = new Map();

/**
 * Subscribe to an event.
 * @returns {Function} unsubscribe
 */
export const on = (event, handler) => {
  if (!listeners.has(event)) listeners.set(event, new Set());
  listeners.get(event).add(handler);
  return () => off(event, handler);
};

export const off = (event, handler) => {
  const handlers = listeners.get(event);
  if (!handlers) return;
  handlers.delete(handler);
  if (handlers.size === 0) listeners.delete(event);
};

export const emit = (event, payload) => {
  const handlers = listeners.get(event);
  if (!handlers) return;
  // copy so handlers may unsubscribe while being called
  [...handlers].forEach(handler => handler(payload));
};

const events = { on, off, emit };

export default events;
